<template>
  <div class="confirm-box">
    <p class="confirm-box-message type-a">
      <i class="sp_order" />주문이 완료되었습니다.
    </p>
    <!-- !orderResult.is_first || -->
    <div class="confirm-header" v-show="orderResult.cfm_kind === 'VCALL'">
			<div class="confirm-header__title">
				주문하신 마이팩이 리더님 댁으로 안전하게 배송되오니, 조금만 기다려 주시기 바랍니다.
			</div>
			<!-- <p class="confirm-header__text">(주문내역에 픽업예약으로 노출되지만 배송될 예정으로 ABC에 재방문하지 않으셔도 됩니다.)</p> -->
		</div>
    <div class="top_action-area shipping_product-btn">
      <a
        class="btn_default-b"
        @click="$router.push('/mypacks')"
      >주문내역 확인</a>
      <a
        class="btn_default-a"
        @click="$router.push('/')"
      >마이팩 메인</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StateInfo',
  props: {
    orderResult: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/order/complete/partial/StateInfo.vue